import React from 'react';
import './title.css';

const Title = () => {
    return (
        <div>
            <h1 className="title" >NewsDrive</h1>
        </div>
    )
}

export default Title;
